<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <!-- <div class="col-1"></div> -->
      <div class="col" style="text-align: left;font-size: 21px;font-weight: 500;color: #278ecd;">
        1 - Compare Monthly Report
      </div>
    </div>
    <div class="row" style="margin-top: 15px;">
      <div class="col-3">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date_for_milk_sale_report" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date_for_milk_sale_report" class="main-border-class"
          [min]="from_date_for_milk_sale_report" />
      </div>
      <div class="col-2" style="margin-left: 10px;">
        <button (click)="getClickedForMilkSaleReport()"
          style="font-size: 27px;margin-top: 14%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="from_date_for_milk_sale_report == null || to_date_for_milk_sale_report == null">Get</button>
      </div>
      <div class="col" *ngIf="!is_document_available_for_milk_sale_report">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="50">
        </mat-progress-spinner>
      </div>
      <div class="col-3" *ngIf="document_file_for_milk_sale!== null" style="padding: 25px;">
        <button mat-button class="button-class" (click)="downloadClickedForMilkSale()"><i class="material-icons">
            picture_as_pdf
          </i> Download report</button>
      </div>
    </div><br>
    <hr style="background: white;">
    <div class="row">
      <!-- <div class="col-1"></div> -->
      <div class="col" style="text-align: left;font-size: 21px;font-weight: 500;color: #278ecd;">
        2 - Run Commission
      </div>
    </div>
    <div class="row" style="margin-top: 15px;">
      <div class="col-3">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date_for_run" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date_for_run" class="main-border-class" [min]="from_date_for_run" />
      </div>
      <div class="col-2" style="padding: 20px;">
        <button mat-button class="button-class" style="font-size: 20px;" [disabled]="checkRunDiablebutton()"
          (click)="runBoothCommissionCalled()">Run</button> &nbsp; &nbsp;
        <label style="color: lightgray; white-space: pre;">* Take more than a minute</label>
      </div>
      <div class="col">
        <!-- <div class="progress-cont" style="margin-top: 7%;" *ngIf="progress !==0">
          <div class="progress" [style.width]="progress + '%'"
            style="background-color: #dda119; height: 35px; font-size: 20px; padding: 4px;">
            <label style="font-size: 20px; color: white;"
              [style.margin-left]="progress_name + '%'">{{progress}}%</label>
          </div>
        </div> -->
        <label style="color: #5048c4;" *ngIf="is_commission_run">Commission Run Stated. You will get a message to
          <b>{{mobile_number}}</b> once
          the run
          is finished. Try to get the report after 10 mins. Thank you.</label>
      </div>
    </div>
    <div class="row">
      <div class="col-2" style="    margin-left: 25px;">
        <mat-checkbox [(ngModel)]="is_sub_column_available" (change)="subColumnChanged($event)"><label
            style="font-size: 20px;">Sub Column</label>
        </mat-checkbox>
      </div>
      <span *ngIf="is_sub_column_available">
        <div class="col">
          <div class="row"
            *ngFor="let column of sub_column_with_file_list; let column_index=index; let last_index=last; let first_index=first;">
            <div class="col">
              <label for="exampleFormControlFile1">Column Name<i class="material-icons"
                  style="color: red;font-size: 14px;">star</i></label>
              <input type="text" class="input_box" [(ngModel)]="sub_column_with_file_list[column_index]['label']" />
            </div>
            <div class="col">
              <label for="exampleFormControlFile1">Excel File<i class="material-icons"
                  style="color: red;font-size: 14px;">star</i></label>
              <input type="file" class="form-control-file" id="exampleFormControlFile1"
                (change)="convertExcelToBase64($event, column_index)" style="font-size: 20px"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
            </div>
            <div class="col">
              <button mat-fab color="primary" (click)="addNewColumnCalled()" *ngIf="first_index">
                <mat-icon aria-hidden="false">add</mat-icon>
              </button>
              <button mat-fab color="primary" (click)="removeLastColumnCalled(column_index)"
                *ngIf="last_index && !first_index">
                <mat-icon aria-hidden="false">cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </span>

    </div>
    <div lass="row" *ngIf="global_config != null">
      <div class="col-6">
        <table class="table table-bordered">
          <tr>
            <td>TDS</td>
            <td>{{global_config['tds']['value']}}%</td>
          </tr>
          <tr>
            <td>Slip Charge</td>
            <td>{{global_config['slip_charge']['value']}} R.s</td>
          </tr>
          <tr>
            <td>Insurance</td>
            <td>{{global_config['agent_insurance_on_commission_deduction']['value']}}%</td>
          </tr>
        </table>
      </div>
    </div><br>
    <hr style="background: white;">
    <div class="row">
      <!-- <div class="col-1"></div> -->
      <div class="col" style="text-align: left;font-size: 21px;font-weight: 500;color: #278ecd;">
        3 - Download Commission Report
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <label>Select Month <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <mat-select class="form-control" [(ngModel)]="selected_month_for_report">
          <mat-option *ngFor="let month of month_list_for_last_12_months" [value]=month>
            {{month['month_in_string']}} - {{month['year']}}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-3" style="padding: 20px;">
        <button mat-button class="button-class" style="font-size: 20px;" [disabled]="selected_month_for_report == null"
          (click)="getClicked()">Get</button>
      </div>
    </div>
    <label *ngIf="run_split.length !== 0">Select Split Date Range</label>
    <div class="row">
      <div class="col-4" *ngFor="let split of run_split">
        <button mat-button style="color: white; margin-bottom: 10px;"
          [style.background]="backgroundColorForRunSpliList(split['id'])"
          (click)="runSpitClickCalled(split)">{{split['split']}} - from
          {{split['run_from'] | date}} to {{split['run_to'] | date}}</button>
      </div>
    </div><br>
    <!-- <div class="row">
      <div *ngIf="!is_document_available">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
        </mat-progress-spinner>
      </div>
    </div> -->
    <div class="row" *ngIf="selected_run_split.hasOwnProperty('id')">
      <div class="col-8">
        <table class="table table-bordered">
          <tr>
            <td>1.</td>
            <td>Commission Report</td>
            <td style="text-align: center;"> <button [disabled]="document_data.hasOwnProperty('commission_report_c1')"
                mat-button class="button-class" (click)="generateReportCalled('commission_report_c1')">
                Generate Report
                <mat-icon *ngIf="!this.is_document_available_dict['commission_report_c1']">
                  <mat-spinner color="accent" diameter="20"></mat-spinner>
                </mat-icon>
              </button>
            </td>
            <td style="text-align: center;" *ngIf="document_data.hasOwnProperty('commission_report_c1')"> <button
                mat-button class="button-class" (click)="downloadClicked('commission_report_c1', 'excel')"
                *ngIf="document_data['commission_report_c1'].hasOwnProperty('excel_file_name')"><i
                  class="material-icons">get_app</i>
                Download Excel</button></td>
            <td style="text-align: center;" *ngIf="document_data.hasOwnProperty('commission_report_c1')"> <button
                mat-button class="button-class" (click)="downloadClicked('commission_report_c1', 'pdf')"
                *ngIf="document_data['commission_report_c1'].hasOwnProperty('pdf_file_name')"><i
                  class="material-icons">picture_as_pdf</i>
                Download Pdf</button></td>
          </tr>
          <tr>
            <td>2.</td>
            <td>Commission Report C1b</td>
            <td style="text-align: center;"> <button [disabled]="document_data.hasOwnProperty('commission_report_c1b')"
                mat-button class="button-class" (click)="generateReportCalled('commission_report_c1b')">
                Generate Report
                <mat-icon *ngIf="!this.is_document_available_dict['commission_report_c1b']">
                  <mat-spinner color="accent" diameter="20"></mat-spinner>
                </mat-icon>
              </button>
            </td>
            <td style="text-align: center;" *ngIf="document_data.hasOwnProperty('commission_report_c1b')"> <button
                mat-button class="button-class" (click)="downloadClicked('commission_report_c1b', 'excel')"
                *ngIf="document_data['commission_report_c1b'].hasOwnProperty('excel_file_name')"><i
                  class="material-icons">get_app</i>
                Download Excel</button></td>
            <td style="text-align: center;" *ngIf="document_data.hasOwnProperty('commission_report_c1b')"> <button
                mat-button class="button-class" (click)="downloadClicked('commission_report_c1b', 'pdf')"
                *ngIf="document_data['commission_report_c1b'].hasOwnProperty('pdf_file_name')"><i
                  class="material-icons">picture_as_pdf</i>
                Download Pdf</button></td>
          </tr>
          <tr>
            <td>3.</td>
            <td>Commission Bank Statement</td>
            <td style="text-align: center;"> <button [disabled]="document_data.hasOwnProperty('commission_report_c2')"
                mat-button class="button-class" (click)="generateReportCalled('commission_report_c2')">
                Generate Report
                <mat-icon *ngIf="!this.is_document_available_dict['commission_report_c2']">
                  <mat-spinner color="accent" diameter="20"></mat-spinner>
                </mat-icon>
              </button>
            </td>
            <td style="text-align: center;" *ngIf="document_data.hasOwnProperty('commission_report_c2')"> <button
                mat-button class="button-class" (click)="downloadClicked('commission_report_c2', 'excel')"
                *ngIf="document_data['commission_report_c2'].hasOwnProperty('excel_file_name')"><i
                  class="material-icons">get_app</i>
                Download Excel</button></td>
            <td style="text-align: center;" *ngIf="document_data.hasOwnProperty('commission_report_c2')"> <button
                mat-button class="button-class" (click)="downloadClicked('commission_report_c2', 'pdf')"
                *ngIf="document_data['commission_report_c2'].hasOwnProperty('pdf_file_name')"><i
                  class="material-icons">picture_as_pdf</i>
                Download Pdf</button></td>
          </tr>
          <tr>
            <td>3.</td>
            <td>Commission Bank Statement C2b</td>
            <td style="text-align: center;"> <button [disabled]="document_data.hasOwnProperty('commission_report_c2b')"
                mat-button class="button-class" (click)="generateReportCalled('commission_report_c2b')">
                Generate Report
                <mat-icon *ngIf="!this.is_document_available_dict['commission_report_c2b']">
                  <mat-spinner color="accent" diameter="20"></mat-spinner>
                </mat-icon>
              </button>
            </td>
            <td style="text-align: center;" *ngIf="document_data.hasOwnProperty('commission_report_c2b')"> <button
                mat-button class="button-class" (click)="downloadClicked('commission_report_c2b', 'excel')"
                *ngIf="document_data['commission_report_c2b'].hasOwnProperty('excel_file_name')"><i
                  class="material-icons">get_app</i>
                Download Excel</button></td>
          </tr>
          <tr>
            <td>4.</td>
            <td>Commission Report 3</td>
            <td style="text-align: center;"> <button [disabled]="document_data.hasOwnProperty('commission_report_c3')"
                mat-button class="button-class" (click)="generateReportCalled('commission_report_c3')">
                Generate Report
                <mat-icon *ngIf="!this.is_document_available_dict['commission_report_c3']">
                  <mat-spinner color="accent" diameter="20"></mat-spinner>
                </mat-icon>
              </button>
            </td>
            <td style="text-align: center;" *ngIf="document_data.hasOwnProperty('commission_report_c3')"> <button
                mat-button class="button-class" (click)="downloadClicked('commission_report_c3', 'excel')"
                *ngIf="document_data['commission_report_c3'].hasOwnProperty('excel_file_name')"><i
                  class="material-icons">get_app</i>
                Download Excel</button></td>
            <td style="text-align: center;" *ngIf="document_data.hasOwnProperty('commission_report_c3')"> <button
                mat-button class="button-class" (click)="downloadClicked('commission_report_c3', 'pdf')"
                *ngIf="document_data['commission_report_c3'].hasOwnProperty('pdf_file_name')"><i
                  class="material-icons">picture_as_pdf</i>
                Download Pdf</button></td>
          </tr>
          <tr>
            <td>5.</td>
            <td>Commission Report 4</td>
            <td style="text-align: center;"> <button [disabled]="document_data.hasOwnProperty('commission_report_c4')"
                mat-button class="button-class" (click)="generateReportCalled('commission_report_c4')">
                Generate Report
                <mat-icon *ngIf="!this.is_document_available_dict['commission_report_c4']">
                  <mat-spinner color="accent" diameter="20"></mat-spinner>
                </mat-icon>
              </button>
            </td>
            <td style="text-align: center;" *ngIf="document_data.hasOwnProperty('commission_report_c4')"> <button
                mat-button class="button-class" (click)="downloadClicked('commission_report_c4', 'excel')"
                *ngIf="document_data['commission_report_c4'].hasOwnProperty('excel_file_name')"><i
                  class="material-icons">get_app</i>
                Download Excel</button></td>
            <td style="text-align: center;" *ngIf="document_data.hasOwnProperty('commission_report_c4')"> <button
                mat-button class="button-class" (click)="downloadClicked('commission_report_c4', 'pdf')"
                *ngIf="document_data['commission_report_c4'].hasOwnProperty('pdf_file_name')"><i
                  class="material-icons">picture_as_pdf</i>
                Download Pdf</button></td>
          </tr>
          <tr>
            <td>6.</td>
            <td>Commission Certificate</td>
            <td style="text-align: center;"> <button [disabled]="document_data.hasOwnProperty('commission_report_c5')"
                mat-button class="button-class" (click)="generateReportCalled('commission_report_c5')">
                Generate Report
                <mat-icon *ngIf="!this.is_document_available_dict['commission_report_c5']">
                  <mat-spinner color="accent" diameter="20"></mat-spinner>
                </mat-icon>
              </button>
            </td>
            <td style="text-align: center;" *ngIf="document_data.hasOwnProperty('commission_report_c5')"> <button
                mat-button class="button-class" (click)="downloadClicked('commission_report_c5', 'pdf')"
                *ngIf="document_data['commission_report_c5'].hasOwnProperty('pdf_file_name')"><i
                  class="material-icons">picture_as_pdf</i>
                Download Pdf</button></td>
          </tr>
          <tr>
            <td>7.</td>
            <td>Agent Slip Charge</td>
            <td style="text-align: center;"> <button
                [disabled]="document_data.hasOwnProperty('commission_report_slip_charge')" mat-button
                class="button-class" (click)="generateReportCalled('commission_report_slip_charge')">
                Generate Report
                <mat-icon *ngIf="!this.is_document_available_dict['commission_report_slip_charge']">
                  <mat-spinner color="accent" diameter="20"></mat-spinner>
                </mat-icon>
              </button>
            </td>
            <td style="text-align: center;" *ngIf="document_data.hasOwnProperty('commission_report_slip_charge')">
              <button mat-button class="button-class" (click)="downloadClicked('commission_report_slip_charge', 'pdf')"
                *ngIf="document_data['commission_report_slip_charge'].hasOwnProperty('pdf_file_name')"><i
                  class="material-icons">picture_as_pdf</i>
                Download Pdf</button>
            </td>
          </tr>

        </table>
      </div>
    </div>
    <!-- <div *ngIf="!is_document_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div class="row" *ngIf="document_file!== null">
      <div class="col-6"></div>
      <div class="col-6">
        <div class="row">
          <div class="col-4">
          </div>
          <div class="col-4">
            <button mat-button class="button-class" (click)="downloadClicked()"><i class="material-icons">
                get_app
              </i> Download Excel</button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</section>
